export default __webpack_public_path__ + "static/media/Project-1-SingleProject-MainImg.24f1149a.png";